/**
 *
 * AdministratorBCFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';
import {TENANT_ANNOUNCEMENT_FORM, TENANT_ANNOUNCEMENT_FORM_DIALOG} from './constants';


export function TenantFormDialog({form, viewName}) {
    return (
        <AdvancedFormDialog
            name={TENANT_ANNOUNCEMENT_FORM_DIALOG}
            formName={TENANT_ANNOUNCEMENT_FORM}
            advancedForm={React.cloneElement(form, {viewName})}
            addModeTitle="Новое объявление"
            editModeTitle="Изменение объявления"
            viewModeTitle="Просмотр объявления"
            copyModeTitle="Копирование объявления"
        />
    );
}

TenantFormDialog.propTypes = {
    form: PropTypes.node.isRequired,
};

